// $ = $Query.noConflict(); 

$(window).on('load', function()
{

});

$(function() {

    var list = $(".items .item");
    var numToShow = 6;
    var button = $("#next");
    var numInList = list.length;
    list.hide();
    if (numInList > numToShow) {
        button.show();
    }
    list.slice(0, numToShow).show();

    button.click(function(){
        var showing = list.filter(':visible').length;
        list.slice(showing - 1, showing + numToShow).fadeIn();
        var nowShowing = list.filter(':visible').length;
        if (nowShowing >= numInList) {
            button.hide();
        }
    });

    var parameters = GetURLParameter('status');
    if(parameters == 'confirm') {
        $('.msg, .checkPoint').slideDown('fast');

        // Confirmation validation
        var checkPoints = $('input[name="s1_confirmed"], input[name="s2_confirmed"], input[name="s3_confirmed"]'),
            count = 0;
        checkPoints.change(function() {
            if($(this).prop('checked')) {
                $(this).parent().find('i').removeClass('fa-exclamation-circle').addClass('fa-check-circle');
                $(this).parent().removeClass('text-red').addClass('text-success');

                $(this).parents().eq(1).next().find('.form-control').addClass('disabled').attr('disabled', 'disabled');
                count++;
                // console.log(count);
            } else {
                $(this).parent().find('i').removeClass('fa-check-circle').addClass('fa-exclamation-circle');
                $(this).parent().removeClass('text-success').addClass('text-red');
                $(this).parents().eq(1).next().find('.form-control').removeClass('disabled').removeAttr("disabled");
                count--;
            }
            console.log(count);

            if(count == 3) {
                $('.msg .alert').slideUp('fast');
                $('.action').slideDown('fast');
            } else {
                $('.msg .alert').slideDown('fast');
                $('.action').slideUp('fast');
            }
        });
        
        // var checkPointEach = $('.checkPoint');
        // checkPointEach.each(function() {

        // });
        
    }

    $('.navbar-nav li.no-link > a').click(function(e) {
        e.preventDefault();
    });

    // $("#countdown").countdown({
    //     date: "18 June 2020 16:00:00", 
    //     format: "on"
    // });

    $('.navbar-toggler[data-id=headers-1-sidebar-toggle]').click(function(e) {
        e.preventDefault();
        $('#headers-1-sidebar').toggleClass('show');
    });
    $('.navbar-toggler[data-id=headers-1-sidebar-close]').click(function(e) {
        e.preventDefault();
        $('#headers-1-sidebar').removeClass('show');
    });
});

var mySwiper = new Swiper('#slider-customers-3', {
    speed: 400,
    navigation: {
      nextEl: '#slider-customers-3-next',
      prevEl: '#slider-customers-3-prev',
    },
    pagination: {
      el: '#slider-customers-3-pagination',
      clickable: true
    }
});

var mySwiper = new Swiper('#slider-right-7', {
    speed: 400,
    navigation: {
    nextEl: '#slider-right-7-next',
    prevEl: '#slider-right-7-prev',
    },
    pagination: {
    el: '#slider-right-7-pagination',
    clickable: true
    }
});

var mySwiper = new Swiper('#slider-customers-4', {
    speed: 400,
    spaceBetween: 30,
    navigation: {
      nextEl: '#slider-customers-4-next',
      prevEl: '#slider-customers-4-prev',
    },
    pagination: {
      el: '#slider-customers-4-pagination',
      clickable: true
    }
});

var mySwiper = new Swiper('#slider-left-7', {
    speed: 400,
    navigation: {
      nextEl: '#slider-left-7-next',
      prevEl: '#slider-left-7-prev',
    },
    pagination: {
      el: '#slider-left-7-pagination',
      clickable: true
    }
});

function GetURLParameter(sParam){
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');

    for (var i = 0; i < sURLVariables.length; i++)
    {
        var sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] == sParam)
        {
            return sParameterName[1];
        }
    }
}​